import React from 'react';
import { Button, Table } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';

import { groupBy } from '../../../utils/collection';
import { sortByFields } from '../sort';
import DeleteButton from '../../common/DeleteButton';

const prepareColumns = (onUpdate, onDelete, onRestore, hasPermission) => {
  return [
    {
      title: 'Group ID',
      dataIndex: 'groupId',
      key: 'groupId',
    },
    {
      title: 'Permissions',
      key: 'permissions',
      render: (text, record) => <div>{record.permissions.join(', ')}</div>,
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <div style={{ display: 'flex' }}>
          <Button
            data-test="edit-group_button"
            className="square-icon-button"
            style={{ border: '1px solid transparent', backgroundColor: 'transparent' }}
            onClick={() => onUpdate(record)}
          >
            <EditOutlined />
          </Button>
          <DeleteButton onDelete={() => onDelete(record.groupId)}>
            <div>
              Are you sure to permanently delete{' '}
              <span style={{ fontWeight: 'bold' }}>{record.groupId}</span>?
            </div>
          </DeleteButton>
        </div>
      ),
      permission: true,
    },
  ].filter((item) => (hasPermission ? true : !item.permission));
};

export const prepareDataSource = (groups) => {
  const tempGroups = [...groups].map((group) => ({ ...group, key: group.groupId }));
  const separatedArr = groupBy(
    tempGroups,
    (item) => (/^[a-z]/i.test(item.groupId) ? 'startsWithoutSymbol' : 'startsWithSymbol'),
    { startsWithoutSymbol: [], startsWithSymbol: [] }
  );

  sortByFields(separatedArr.startsWithoutSymbol, 'groupId', 'permissions');
  sortByFields(separatedArr.startsWithSymbol, 'groupId', 'permissions');

  return separatedArr.startsWithoutSymbol.concat(separatedArr.startsWithSymbol);
};

// TODO: very similar to segments table
const GroupsTablePane = ({ onAdd, onUpdate, onDelete, onRestore, groups, hasPermission }) => {
  const renderFooter = () => (
    <div>
      <Button onClick={() => onAdd()} disabled={!hasPermission}>
        <PlusOutlined />
        Add group
      </Button>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
      <div style={{ display: 'flex', alignItems: 'flexStart', marginBottom: 16 }}>
        {/* <Input
        placeholder="Search by name"
        value={filterValue || ''}
        onChange={(e) => onFilterValueChange(e.target.value)}
        style={{width: 150}}
      /> */}
      </div>
      <Table
        columns={prepareColumns(onUpdate, onDelete, onRestore, hasPermission)}
        dataSource={prepareDataSource(groups)}
        size="middle"
        pagination={{ defaultPageSize: 20, showSizeChanger: true }}
        style={{ marginBottom: 16 }}
        footer={renderFooter}
      />
    </div>
  );
};

export default GroupsTablePane;
